import { useMemo } from 'react';
import DefaultJSONPretty from 'react-json-pretty';

import Box from '@mui/material/Box';

import { CopyToClipboard } from './CopyToClipboard';

interface Props {
  readonly id: string;
  readonly data: unknown;
}

export const JSONPretty = ({ id, data }: Readonly<Props>) => {
  const content = useMemo(() => JSON.stringify(data, null, 2), [data]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexGrow: 1,
        overflow: 'auto',
        position: 'relative',
      }}
    >
      <Box sx={{ position: 'absolute', right: 16, top: 32, zIndex: 1 }}>
        <CopyToClipboard content={content} size="small" />
      </Box>
      <DefaultJSONPretty
        booleanStyle="color:#ac81fe;"
        data={data}
        errorStyle="line-height:1.3;color:#66d9ef;background:#272822;overflow:auto;border-radius:4px;padding:10px"
        id={`json-pretty-${id}`}
        keyStyle="color:#f92672;"
        mainStyle="line-height:1.3;color:#66d9ef;background:#272822;overflow:auto;border-radius:4px;padding:10px;flex-grow:1;"
        stringStyle="color:#fd971f;"
        // eslint-disable-next-line react/forbid-component-props
        style={{ display: 'flex', flexGrow: 1 }}
        valueStyle="color:#a6e22e;"
      />
    </Box>
  );
};
